import { createContext } from "react";
import useGetRestaurants from "../../hooks/useGetRestaurants";

const getResList = useGetRestaurants();

const restaurantContext = createContext({
    restaurants:getResList
})

export default restaurantContext;